export const UPDATE_INTESTATARIO_CARTA = 'UPDATE_INTESTATARIO_CARTA';